import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/010-upload.png';
const _withScopeId = n => (_pushScopeId("data-v-d0ddbe6e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "single main"
};
const _hoisted_2 = {
  class: "single-top"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload-icon",
  src: _imports_0
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode("将图片拖拽至此，或 "), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1));
const _hoisted_5 = ["src"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "upload-img-show"
};
const _hoisted_8 = {
  class: "box"
};
const _hoisted_9 = {
  class: "form-box-box"
};
const _hoisted_10 = {
  class: "radio-div"
};
const _hoisted_11 = {
  class: "span-radio"
};
const _hoisted_12 = {
  class: "span-radio"
};
const _hoisted_13 = {
  class: "upload-logo-div"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload-icon",
  src: _imports_0
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode("将图片拖拽至此，或 "), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1));
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  style: {
    "padding-left": "0px",
    "padding-top": "40px"
  }
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "120px"
  }
}, null, -1));
const _hoisted_19 = {
  class: "img-box-r"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "img-drag-box"
};
const _hoisted_22 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_color_picker = _resolveComponent("el-color-picker");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_vue_draggable_resizable = _resolveComponent("vue-draggable-resizable");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_upload, {
    class: "upload-logo",
    drag: "",
    action: "#",
    "list-type": "picture-card",
    "auto-upload": false,
    "on-success": $options.onSuccess
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4]),
    file: _withCtx(({
      file
    }) => [_createElementVNode("img", {
      class: "el-upload-list__item-thumbnail",
      src: file.url,
      alt: ""
    }, null, 8, _hoisted_5), _createElementVNode("span", {
      class: "el-upload-list__item-preview span-icon-btn",
      onClick: $event => $options.handlePictureCardPreview(file)
    }, " 给当前图片设置水印 ", 8, _hoisted_6)]),
    _: 1
  }, 8, ["on-success"])]), $data.dialogVisible ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, [_withDirectives(_createElementVNode("input", {
    type: "radio",
    name: "type",
    value: "1",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.logoType = $event)
  }, null, 512), [[_vModelRadio, $data.logoType]]), _createTextVNode(" 文字水印 ")]), _createElementVNode("span", _hoisted_12, [_withDirectives(_createElementVNode("input", {
    type: "radio",
    name: "type",
    value: "2",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.logoType = $event)
  }, null, 512), [[_vModelRadio, $data.logoType]]), _createTextVNode(" 图片水印 ")])]), _createVNode(_component_el_form, {
    model: $data.logoStyle,
    "label-width": "auto",
    style: {
      "max-width": "600px"
    }
  }, {
    default: _withCtx(() => [$data.logoType === '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: "水印文字：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        ref: "textarea",
        style: {
          "height": "80px"
        },
        class: "url-textarea",
        modelValue: $data.logoStyle.logoTxt,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.logoStyle.logoTxt = $event),
        type: "textarea",
        placeholder: "请输入文字作为水印"
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $data.logoType === '2' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 1,
      label: "上传图片作为水印：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_upload, {
        class: "upload",
        drag: "",
        action: "#",
        "list-type": "picture-card",
        "auto-upload": false,
        "on-success": $options.onSuccess2,
        "on-change": $options.onChange
      }, {
        default: _withCtx(() => [_hoisted_14, _hoisted_15]),
        file: _withCtx(({
          file
        }) => [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_16)]),
        _: 1
      }, 8, ["on-success", "on-change"])])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "调整水印大小：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.scale,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.logoStyle.scale = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 0.01,
        min: 0,
        max: "30"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), $data.logoType === '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 2,
      label: "水印颜色：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_color_picker, {
        modelValue: $data.logoStyle.color,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.logoStyle.color = $event),
        size: "large",
        "show-alpha": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $data.logoType === '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 3,
      label: "水印背景色：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_color_picker, {
        modelValue: $data.logoStyle.bg,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.logoStyle.bg = $event),
        size: "large",
        "show-alpha": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $data.logoType === '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 4,
      label: "水印字体大小：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.fontSize,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.logoStyle.fontSize = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 1,
        min: 1,
        max: "500"
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $data.logoType === '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 5,
      label: "水印宽度：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.width,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.logoStyle.width = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 5,
        min: 10,
        max: "3000"
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "水印旋转角度：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.rotate,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.logoStyle.rotate = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 0.1,
        min: 0,
        max: "360"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "水印透明度：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.opacity,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.logoStyle.opacity = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 0.01,
        min: 0.01,
        max: "1"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "水印圆角：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.borderRadius,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.logoStyle.borderRadius = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 1,
        min: 0,
        max: "2000"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "水印阴影：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.bgShadow,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.logoStyle.bgShadow = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 1,
        min: 0,
        max: "20"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "水印阴影色：",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_color_picker, {
        modelValue: $data.logoStyle.shadowColor,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.logoStyle.shadowColor = $event),
        size: "large",
        "show-alpha": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), $data.logoType === '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 6,
      label: "水印字体",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.logoStyle.family,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.logoStyle.family = $event),
        placeholder: "请选择字体"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "PingFang SC",
          value: "PingFang SC"
        }), _createVNode(_component_el_option, {
          label: "Arial",
          value: "Arial"
        }), _createVNode(_component_el_option, {
          label: "微软雅黑",
          value: "Microsoft YaHei"
        }), _createVNode(_component_el_option, {
          label: "宋体",
          value: "宋体"
        }), _createVNode(_component_el_option, {
          label: "Calibri",
          value: "Calibri"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.downloadAll,
        disabled: _ctx.disabledBtn
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.downloadTxt), 1)]),
        _: 1
      }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
        onClick: _cache[14] || (_cache[14] = $event => $data.dialogVisible = false)
      }, {
        default: _withCtx(() => [_createTextVNode("关闭")]),
        _: 1
      })])]),
      _: 1
    }), _hoisted_18]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: "img-box-logo",
    style: _normalizeStyle(`height: ${$data.h}px; width: ${$data.w}px;`),
    ref: "imgBoxLogo"
  }, [_createElementVNode("img", {
    class: "el-upload-list__item-thumbnail img-img",
    src: $data.dialogImageUrl,
    alt: "",
    ref: "imgRef"
  }, null, 8, _hoisted_20), _createElementVNode("div", _hoisted_21, [$data.logoStyle.logoTxt !== '' ? (_openBlock(), _createBlock(_component_vue_draggable_resizable, {
    key: 0,
    w: $data.logoStyle.width,
    h: $data.logoStyle.height,
    parent: ".img-box-logo"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      ref: "logoSpan",
      style: _normalizeStyle(`color: ${$data.logoStyle.color};
                          width: ${$data.logoStyle.width}px;
                          height: ${$data.logoStyle.height}px;
                          opacity: ${$data.logoStyle.opacity};
                          display: inline-block;
                          background-color: ${$data.logoStyle.bg};
                          box-shadow: 0 0 ${$data.logoStyle.bgShadow}px ${$data.logoStyle.shadowColor};
                          font-family: ${$data.logoStyle.family};
                          font-size: ${$data.logoStyle.fontSize}px;
                          border-radius: ${$data.logoStyle.borderRadius}px;
                          transform: rotate(${$data.logoStyle.rotate}deg) scale(${$data.logoStyle.scale});
                          transform-origin: center center;
                          line-height: ${$data.logoStyle.height}px;
                          `)
    }, _toDisplayString($data.logoStyle.logoTxt), 5)]),
    _: 1
  }, 8, ["w", "h"])) : _createCommentVNode("", true), $data.logoStyle.logoImg ? (_openBlock(), _createBlock(_component_vue_draggable_resizable, {
    key: 1,
    w: $data.logoStyle.width,
    h: $data.logoStyle.height,
    parent: ".img-box-logo"
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      ref: "logoSpan",
      style: _normalizeStyle(`color: ${$data.logoStyle.color};
                          width: ${$data.logoStyle.imgwidth}px;
                          height: ${$data.logoStyle.imgheight}px;
                          display: inline-block;
                          opacity: ${$data.logoStyle.opacity};
                          background-color: ${$data.logoStyle.bg};
                          box-shadow: 0 0 ${$data.logoStyle.bgShadow}px ${$data.logoStyle.shadowColor};
                          font-family: ${$data.logoStyle.family};
                          font-size: ${$data.logoStyle.fontSize}px;
                          transform: rotate(${$data.logoStyle.rotate}deg) scale(${$data.logoStyle.scale});
                          border-radius: ${$data.logoStyle.borderRadius}px;
                          line-height: ${$data.logoStyle.height}px;
                          `),
      src: $data.logoStyle.logoImg
    }, null, 12, _hoisted_22)]),
    _: 1
  }, 8, ["w", "h"])) : _createCommentVNode("", true)])], 4)])])])) : _createCommentVNode("", true)]);
}